import type { Locale } from "@borealis/layout-express";
import { i18n } from "@lingui/core";

export const dynamicLoadTranslations = async (locale: Locale) => {
  const { messages } = await import(`../locales/${locale}.mjs`);

  i18n.load(locale, messages);
};
